.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  white-space: nowrap;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  line-height: 18px;
  font-weight: 600;
}

.resolved,
.resolved_via_ai {
  background: #eaf6ed;
  color: #166c3b;
}

.processing,
.reply_needed {
  background: #eff4fe;
  color: var(--info);
}

.needs_attention {
  background: #fff0e9;
  color: #a33b04;
}

.default {
  background: #f5f5f5;
  color: var(--text-secondary);
}
